import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-card',
  templateUrl: './generic-card.component.html',
  styleUrls: ['./generic-card.component.scss']
})
export class GenericCardComponent implements OnInit {

  @Input() info: any
  @Input() valor: number
  @Input() anotaciones: boolean
  expand:boolean = false

  constructor() { }

  ngOnInit(): void {            
  }

  test(){    
    if (this.expand) {
      this.expand = false
    }else{
      this.expand = true
    }
  }

}
